export const formatErrorMessage = (errMsg: string | undefined): string => {
  if (typeof errMsg === 'string' && errMsg.length > 0) {
    const newMsg = errMsg.replace(/_/g, ' ');
    return `${newMsg.slice(0, 1)}${newMsg.slice(1).toLowerCase()}.`;
  } else {
    return 'Something went wrong.';
  }
};
